import { render, staticRenderFns } from "./SwitchToDesktop.vue?vue&type=template&id=3c274ba3&scoped=true&"
import script from "./SwitchToDesktop.vue?vue&type=script&lang=js&"
export * from "./SwitchToDesktop.vue?vue&type=script&lang=js&"
import style0 from "./SwitchToDesktop.vue?vue&type=style&index=0&id=3c274ba3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c274ba3",
  null
  
)

export default component.exports